<template>

  <div>
    <message v-for="msg of messages" :severity="msg.severity" :key="msg.content">{{msg.content}}</message>
    <Toolbar>
      <template #right>

        <Dropdown id="season-select" v-model="selectedSubscription" :options="subscriptions" optionLabel="getSeasonYear"
                  placeholder="Wähle eine Saison"
                  v-on:change="switchSubscription">
          <template #value="slotProps">
            <div v-if="slotProps.value">
              <div>{{ getSeasonYear(slotProps.value) }}</div>
            </div>
            <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
          </template>
          <template #option="slotProps">
            <div>
              <div>{{ getSeasonYear(slotProps.option) }}</div>
            </div>
          </template>
        </Dropdown>

      </template>
    </Toolbar>

    <TabView class="p-mt-3">

      <!-- ===========================================================================-->
      <!-- M A T C H D A Y Classification :  Overview based on the day classification -->
      <!-- ===========================================================================-->
      <TabPanel header="Spieltage">
        <div class="p-fluid p-grid p-mt-3">
          <span v-touch:swipe.left="swipeLeft" v-touch:swipe.right="swipeRight">

          <Panel :header="getMatchDayHeader()" :toggleable="false">

                  <template #icons>
                    <Button @click="decreaseMatchDay" icon="pi pi-arrow-circle-left"
                            class="p-button-rounded p-button-text p-button-lg p-d-none p-d-md-inline-flex"
                            :disabled="matchDayNumber === 1"/>
                    <Button @click="increaseMatchDay" icon="pi pi-arrow-circle-right"
                            class="p-button-rounded p-button-text p-button-lg p-d-none p-d-md-inline-flex"
                            :disabled="matchDayNumber === lastCalculatedMatchDay"/>
                  </template>

            <DataTable :value="matchDay.matchDayUserPoints"
                       :scrollable="true" scrollHeight="flex"
                       :style="{height: '70vh'}"
                       rowGroupMode="rowspan" :loading="isLoading"
                       groupRowsBy="userDayRanking"
                       class="p-datatable-sm"
                       sortField="userDayPoints"
                       :sortOrder="-1">

              <template #empty>
                No Users found
              </template>

              <template #loading>
                Loading...
              </template>

              <Column field="userDayRanking" header="#" headerStyle="width:2em">
                  <template #body="slotProps">
                    <span>{{ slotProps.data.userDayRanking }}</span>
                  </template>
              </Column>

             <column field="userId.profileImageId" header-style="width:3.5em;">
               <template #body="slotProps">
                 <img v-if="showDayProfileImage(slotProps.data)" :src="slotProps.data.userId.url" class="avatar-round"/>
               </template>
             </column>

              <Column field="userId.name" header="Name">
                  <template #body="slotProps">
                    <div :class="rowClass(slotProps.data)">
                      {{ slotProps.data.userId.name }} {{ slotProps.data.userId.surname }}
                      <font-awesome-icon style="color: #FFD700;"
                                         v-if="slotProps.data.userDayRanking === 1 && matchDay.isFinished ? true : false"
                                         icon="medal"/>
                    </div>
                  </template>
              </Column>

              <Column field="userDayPoints" header="Punkte" header-style="text-align: right"
                      body-style="text-align: right">
                  <template #body="slotProps">
                    <div>{{ slotProps.data.userDayPoints }}</div>
                  </template>
              </Column>

            </DataTable>

          </Panel>
        </span>
        </div>

      </TabPanel>

      <!-- ===========================================================================-->
      <!-- S E A S O N  Classification :  Overview based on the season classification -->
      <!-- ===========================================================================-->
      <TabPanel header="Saison">

        <Panel header="Gesamtübersicht">

          <!-- Data Table for small devices -->
          <DataTable id="season-class"
                     :value="seasonPoints" :filters="filters" rowGroupMode="rowspan" :loading="isLoading"
                     :scrollable="true" scrollHeight="flex"
                     :style="{height: '70vh'}"
                     groupRowsBy="userSeasonRanking"
                     class="p-datatable-sm" sortField="userSeasonPoints" :sortOrder="-1">

            <template #empty>
              No users found.
            </template>

            <template #loading>
              Loading...
            </template>

            <Column field="userSeasonRanking" header="#" headerStyle="width:2em">
              <template #body="slotProps">
                {{ slotProps.data.userSeasonRanking }}
              </template>
            </Column>

            <Column field="userSeasonRankDiff" headerStyle="width:3em">
              <template #body="slotProps">
                <font-awesome-icon v-if="slotProps.data.userSeasonRankDiff < 0 ? true : false"
                                   style="color: green;" icon="angle-up"/>
                <font-awesome-icon v-if="slotProps.data.userSeasonRankDiff > 0 ? true : false"
                                   style="color: red;" icon="angle-down"/>
                {{ getRankingDifference(slotProps.data.userSeasonRankDiff) }}
              </template>
            </Column>

             <column field="userId.profileImageId" header-style="width:3.5em;">
               <template #body="slotProps">
                 <img v-if="showProfileImage(slotProps.data)" :src="slotProps.data.userId.url" class="avatar-round"/>
               </template>
             </column>

            <Column field="userId.surname" header="Name">
              <template #body="slotProps">
                <div :class="rowClass(slotProps.data)">
                  {{ slotProps.data.userId.name }} {{ slotProps.data.userId.surname }}
                  <font-awesome-icon v-if="slotProps.data.userSeasonRanking === 1 ? true : false"
                                     style="color: #FFD700;" icon="crown"/>
                </div>
              </template>
            </Column>

            <Column field="userSeasonPoints" header="Punkte" header-style="width:4.2em; text-align: right"
                    body-style="text-align: right"></Column>

          </DataTable>

        </Panel>
      </TabPanel>
      <!-- ===================================-->
      <!-- /END - S E A S O N  Classification -->
      <!-- ===================================-->

<!--      <TabPanel header="Neue Liste">
        <SeasonRanking :days="seasonPoints"></SeasonRanking>
      </TabPanel>-->

      <TabPanel header="Statistiken">
        <!-- Data Table for small devices -->

        <DataTable :value="seasonWins"
                   :scrollable="true" scrollHeight="flex"
                   :style="{height: '70vh'}"
                   :loading="isLoading"
                   class="p-datatable-sm"
                   sortField="winCount"
                   :sortOrder="-1">

          <template #empty>
            No Users found
          </template>

          <template #loading>
            Loading...
          </template>


          <Column field="name" header="Name">
            <template #body="slotProps">
              <div :class="rowClass(slotProps.data)">
                {{ slotProps.data.name }} {{ slotProps.data.surname }}
              </div>
            </template>
          </Column>


          <Column field="winCount" header="Spieltagssiege" header-style="text-align: right"
                  body-style="text-align: right"></Column>
        </DataTable>

      </TabPanel>

      <!-- The way match points will be calculated -->
      <TabPanel header="Info">

        <Panel header="Sieg">
          <table class="calc-points">

            <thead>
            <th>Szenario</th>
            <th>Punkte</th>
            <th>Beispiel</th>
            </thead>

            <tr>
              <td>Korrekter Tipp, bei mehr als 3 Toren im Spiel</td>
              <td>5</td>
              <td>Tipp 4:1 --> Ergebnis 4:1 = 5 Punkte</td>
            </tr>
            <tr>
              <td>Korrekter Tipp</td>
              <td>4</td>
              <td>Tipp 2:0 --> Ergebnis 2:0 = 4 Punkte</td>
            </tr>
            <tr>
              <td>Tendenz, 1 Tor daneben</td>
              <td>3</td>
              <td>Tipp 2:0 --> Ergebnis 1:0 = 3 Punkte</td>
            </tr>
            <tr>
              <td>Tendenz, Differenz richtig</td>
              <td>2</td>
              <td>Tipp 2:1 --> Ergebnis 1:0 = 2 Punkte</td>
            </tr>
            <tr>
              <td>Tendenz richtig</td>
              <td>1</td>
              <td>Tipp 3:0 --> Ergebnis 1:0 = 1 Punkt</td>
            </tr>

          </table>

        </Panel>
        <br/>
        <Panel header="Unentschieden">
          <table class="calc-points">

            <thead>
            <th>Szenario</th>
            <th>Punkte</th>
            <th>Beispiel</th>
            </thead>
            <tr>
              <td>Korrekter Tipp</td>
              <td>5</td>
              <td>Tipp 2:2 --> Ergebnis 2:2 = 5 Punkte</td>
            </tr>
            <tr>
              <td>Tendenz richtig</td>
              <td>4</td>
              <td>Tipp 2:2 --> Ergebnis 1:1 = 4 Punkte</td>
            </tr>

          </table>

        </Panel>

        <br/>

        <Panel header="Topspiel">
          <table class="calc-points">

            <thead>
            <th>Szenario</th>
            <th>Punkte</th>
            </thead>
            <tr>
              <td>Korrekter Tipp</td>
              <td>+2</td>
            </tr>
            <tr>
              <td>Tendenz richtig</td>
              <td>+1</td>
            </tr>

          </table>

        </Panel>


      </TabPanel>

    </TabView>

  </div>

</template>

<script>
import MatchDayDataService from "../services/match-day-data.service"
import SeasonDataService from "../services/season-data.service"
import CommunityDataService from "../services/community-data.service"
import UserService from "@/services/user.service";
import Promise from "bluebird";
//import SeasonRanking from "../components/SeasonRanking";

export default {
  name: "match-day-class-list",
/*  components: {
    SeasonRanking
  },*/
  props: {
    matchDayNumberProp: {
      Type: Number,
      default: 1
    }
  },
  data() {
    return {
      matchDay: {
        matchDayUserPoints: []
      },
      messages: [],
      selectedSubscription: null,
      subscriptions: [],
      matchDayNumber: 1,
      filters: {},
      isLoading: false,
      fullPage: true,
      currentIndex: -1,
      seasonPoints: [],
      seasonWins: [],
      internalSubscription: null
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },

    currentSeasonYear() {
      return this.$store.state.sys.seasonYear;
    },
    subscription() {
      return this.$store.state.sys.subscription;
    },
    lastCalculatedMatchDay() {
      return this.$store.state.sys.lastCalcMatchDay;
    },

    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_ADMIN');
      }
      return false;
    }
  },
  methods: {
    addComponentMessage(severity, content){
      this.messages.push({severity: severity, content: content});
    },
    removeComponentMessage(){
      this.messages = [];
    },
    prepareStateData() {
      return new Promise((resolve, reject) => {

        this.removeComponentMessage();
        // no season is selected, check if the current active season and subscriptions are set
        if (this.selectedSubscription == null) {
          this.isLoading = true;

          if (this.internalSubscription == null) {
            this.$store.dispatch('sys/getSubscription')
                .then(() => {
                  if(!this.subscription){
                    reject({message: "Sie sind nicht für die aktuelle Saison registriert."});
                  }
                  this.internalSubscription = this.subscription;
                  // console.log("PrepareStateData: " + JSON.stringify(this.internalSubscription));
                  return this.$store.dispatch('sys/getLastCalculatedMatchDay', this.internalSubscription.season);
                })
                .then(() => {
                  resolve();
                })
                .catch(err => {
                  console.log("Error: " + err.message);
                  reject(err);
                })
          }
        }
      });
    },
    retrieveMatchDayUserPoints() {
      this.isLoading = true;
      console.log("MatchDayNumber: " + this.matchDayNumber);

      let requestSubscription = this.internalSubscription;

      if (this.selectedSubscription !== null) {
        requestSubscription = this.selectedSubscription;
      }

      if (requestSubscription == null) {
        this.$store.dispatch('sys/getCurrentSeasonYear')
            .then(() => {
              // console.log("------------------------------------------>");
              return this.$store.dispatch('sys/getSubscription', this.$store.state.sys.seasonYear)
            })
            .then(() => {
              requestSubscription = this.internalSubscription;
              // console.log("RequestSubscription: " + JSON.stringify(requestSubscription));
            })
            .catch(err => {
              console.log("Error: " + err.message);
            })
      }

      let data = {
        dayNumber: this.matchDayNumber,
        seasonYear: this.currentSeasonYear
      }

      if (requestSubscription != null) {
        data.seasonYear = requestSubscription.season.seasonYear;
      }

      MatchDayDataService.getMatchDayUserPointList(data)
          .then(response => {
            // console.log("MatchDayUserPointsList: " + JSON.stringify(response.data));

            if (response.data.matchDayUserPoints) {
              Promise.each(response.data.matchDayUserPoints, (matchDayPointsItem) => {
                if (matchDayPointsItem.userId.profileImageId && matchDayPointsItem.userDayRanking < 4) {
                  return UserService.getUserImageById(matchDayPointsItem.userId)
                      .then(image => {
                        matchDayPointsItem.userId.url = image.data;
                      })
                      .catch(err => {
                        console.log(err);
                      })
                }
              })
                  .then((data) => {
                    this.matchDay = response.data;
                    this.matchDay.matchDayUserPoints = data;
                    this.isLoading = false;
                  })
                  .catch(err => {
                    console.log(err);
                    this.isLoading = false;
                  })
            } else {
              this.matchDay = {matchDayPoints: []};
              this.isLoading = false;
            }
          })
          .catch(() => {
            if (this.matchDayNumber > 1) {
              console.log("Retry with first day.");
              this.matchDayNumber = 1;
              this.retrieveMatchDayUserPoints();
            }
          });
    },

    retrieveSeasonUserPoints() {
      let requestSubscription = this.internalSubscription;

      if (this.selectedSubscription !== null) {
        requestSubscription = this.selectedSubscription;
      }

      if (requestSubscription == null) {
        this.$store.dispatch('sys/getCurrentSeasonYear')
            .then(() => {
              // console.log("------------------------------------------>");
              return this.$store.dispatch('sys/getSubscription', this.$store.state.sys.seasonYear)
            })
            .then(() => {
              requestSubscription = this.internalSubscription;
              // console.log("RequestSubscription: " + JSON.stringify(requestSubscription));
            })
            .catch(err => {
              console.log("Error: " + err.message);
            })
      }

      if (requestSubscription != null) {
        SeasonDataService.getSeasonClassification(requestSubscription)
            .then(response => {
              // console.log(JSON.stringify(response.data));

              Promise.each(response.data, (seasonPointsItem) => {
                if (seasonPointsItem.userId.profileImageId && seasonPointsItem.userSeasonRanking < 4) {
                  return UserService.getUserImageById(seasonPointsItem.userId)
                      .then(image => {
                        seasonPointsItem.userId.url = image.data;
                      })
                      .catch(err => {
                        console.log(err);
                      })
                }
              })
                  .then((data) => {
                    this.seasonPoints = data;
                    // console.log("Images loaded...");
                    this.isLoading = false;
                  })
                  .catch(err => {
                    console.log(err);
                    this.isLoading = false;
                  })
            })
            .catch((err) => {
              console.log(err);
              this.isLoading = false;
              this.seasonPoints = [];
            });
      }
    },

    retrieveSeasonWinClass() {
      let requestSubscription = this.internalSubscription;

      if (this.selectedSubscription !== null) {
        requestSubscription = this.selectedSubscription;
      }

      if (requestSubscription == null) {
        this.$store.dispatch('sys/getCurrentSeasonYear')
            .then(() => {
              // console.log("------------------------------------------>");
              return this.$store.dispatch('sys/getSubscription', this.$store.state.sys.seasonYear)
            })
            .then(() => {
              requestSubscription = this.internalSubscription;
              // console.log("RequestSubscription: " + JSON.stringify(requestSubscription));
            })
            .catch(err => {
              console.log("Error: " + err.message);
            })
      }

      if (requestSubscription != null) {
        MatchDayDataService.getSeasonWinsClassification(requestSubscription)
            .then(response => {
              // console.log(JSON.stringify(response.data));
              this.seasonWins = response.data;
            })
            .catch((err) => {
              console.log(err);
              this.isLoading = false;
            });
      }
    },

    showProfileImage(user) {
      return user.userId.profileImageId && user.userSeasonRanking < 4;
    },

    showDayProfileImage(user) {
      return user.userId.profileImageId && user.userDayRanking < 4;
    },

    getMatchDayHeader() {
      return this.matchDayNumber + ". Spieltag";
    },

    increaseMatchDay() {
      if (this.matchDayNumber === 34) {
        return;
      }
      if (this.matchDayNumber === this.$store.state.sys.lastCalcMatchDay && this.subscription === this.selectedSubscription) return;

      this.matchDayNumber += 1;

      console.log(this.matchDayNumber);
      this.retrieveMatchDayUserPoints();
    },

    getRankingDifference(difference) {
      if (difference < 0) {
        return Math.abs(difference);
      } else if (difference === 0) {
        return "-";
      }
      return difference;
    },

    decreaseMatchDay() {
      if (this.matchDayNumber === 1) {
        return;
      }
      this.matchDayNumber -= 1;
      console.log(this.matchDayNumber);
      this.retrieveMatchDayUserPoints();
    },

    swipeLeft() {
      this.increaseMatchDay();
    },

    getSeasonYear(data) {
      if (data != null) {
        return data.season.seasonYear;
      }
      return "";
    },

    switchSubscription() {
      this.retrieveMatchDayUserPoints();
      this.retrieveSeasonUserPoints();
      this.retrieveSeasonWinClass();

    },

    rowClass(data) {
      console.log("Current User: " + (data.userId._id === this.currentUser.id));
      return data.userId._id === this.currentUser.id ? 'row-accessories' : null;
    },

    swipeRight() {
      this.decreaseMatchDay();
    },

    getAllSubscriptions() {
      return new Promise((resolve, reject) => {
        // console.log("User DefaultCommunity: " + this.currentUser.defaultCommunity);
        CommunityDataService.getAllSubscriptions(this.currentUser.defaultCommunity)
            .then(subscriptions => {
              // console.log("All subscriptions" + JSON.stringify(subscriptions));
              this.subscriptions = subscriptions.data;
              resolve();
            })
            .catch(err => {
              reject(err);
            })
      });
    }
  },
  watch: {
    matchDayNumber: function (newVal, oldVal) {
      console.log("New: " + newVal + " --> Old: " + oldVal);
      this.retrieveMatchDayUserPoints();
    }
  },

  mounted() {
    console.log("MatchDayClassList mounted");
    if (!this.currentUser.subscriptions || !this.currentUser.defaultCommunity) {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    } else {
      this.prepareStateData()
          .then(() => {
            // console.log("Subscription: " + JSON.stringify(this.internalSubscription));
            return this.getAllSubscriptions();
          })
          .then(() => {
            return CommunityDataService.getCurrentSubscription();
          })
          .then(currentSubscription => {
            // console.log("Current Subscription: " + JSON.stringify(currentSubscription));
            this.internalSubscription = currentSubscription.data;

            console.log("LastCalculatedMatchDay: " + this.lastCalculatedMatchDay);
            if (this.lastCalculatedMatchDay === undefined) {
              this.matchDayNumber = 1;
            } else {
              this.matchDayNumber = this.lastCalculatedMatchDay;
            }

            this.retrieveMatchDayUserPoints();
            this.retrieveSeasonUserPoints();
            this.retrieveSeasonWinClass();
          })
          .catch(err => {
            this.addComponentMessage("error", err.message);
            console.log("Error: " + err.message);
            this.isLoading = false;
          })
    }
  }
}
</script>

<style>
.row-accessories {
  background-color: rgb(83, 227, 83) !important;
}

.row-gold-accessories {
  background-color: rgb(212, 175, 55) !important;
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0 #a6d5fa !important;
}

.p-button-rounded:enabled:focus {
  background: transparent;
  box-shadow: 0 0 0 0 #a6d5fa !important;
  border-color: transparent;
}

.p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {
  vertical-align: top !important;
}

.p-panel .p-panel-content {
  padding: 0.1rem !important;
}

.p-tabview-panels {
  padding: 0.2rem !important;
}

.p-col-12 {
  padding: 0.2rem !important;
}

.p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {
  font-size: 0.8em !important;
}

.calc-points {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

.calc-points td, .calc-points th {
  border: 1px solid #ddd;
  padding: 8px;
}

.calc-points tr:nth-child(even) {
  background-color: #f2f2f2;
}

.calc-points tr:hover {
  background-color: #ddd;
}

.calc-points th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #c0c1c0;
  color: white;
}

#season-select .p-inputtext {
  font-size: 0.8rem !important;
}

.avatar-round {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ccc;
  display: block;
}

</style>